import { useMemo } from 'react';
import { applyExcelFormats } from '../../../../utils/excel';
import { TRANSFERS_ANALYTICS_COLUMNS } from '../../../../constants/reports';
import { exportReportFile, processReport } from '../../../../utils/reports';
import ReportActionRow from '../ReportActionRow';
import ReportList from '../ReportList';

function ReportTransfersAnalytics({
  reportTitle,
  reportDetails,
  reportId,
  reportFileName,
  reportType,
  setSpinner,
  report,
}) {
  const { processedReport } = useMemo(
    () => processReport(reportType, report),
    [reportType, report],
  );

  const formattedReport = useMemo(() => {
    if (processedReport.length > 0) {
      return processedReport.map(r =>
        Object.entries(r).reduce((acc, [key, value]) => {
          if (key === 'reconciled') {
            return { ...acc, [key]: value ? 'Yes' : 'No' };
          }

          return {
            ...acc,
            [key]:
              value !== null
                ? applyExcelFormats(value, TRANSFERS_ANALYTICS_COLUMNS[key]?.style?.numFmt)
                : null,
          };
        }, {}),
      );
    }

    return [];
  }, [processedReport]);

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        exportFile={() => exportReportFile({ reportType, reportFileName, report })}
      />
      <ReportList
        report={formattedReport}
        tableColumns={TRANSFERS_ANALYTICS_COLUMNS}
        headerHeight={36}
        rowKey="id"
      />
    </>
  );
}

export default ReportTransfersAnalytics;
